import "../assets/css/projects.css"
import React, { useEffect, useState } from "react";
import { animation, headerSet, showNavLink } from "../Helper/CssHelper";
import { Link } from "react-router-dom";
import ProjectsModal from "./ProjectsModal";
// import ProjectsData from "../data/ProjectsData";

function Projects(props) {
  const ProjectsData = props.ProjectsData;
  // console.log(props)
  const [show, setShow] = useState(false);
  const [project, setProject] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  function handleContent(item) {
    setProject(item);
  }

  useEffect(() => {
    headerSet("Projects | Justin Dsouza");
    showNavLink("projects", "projects-section");
    animation("projects-section");
  }, []);
  return (
    <div>
      {/* <!-- ======= Projects Section ======= --> */}
      <section id="projects-section" className="projects section-show">
        <div className="container">
          <div className="section-title">
            <h2>Projects</h2>
            <p>My Works</p>
          </div>

          {/* <div className="row">
            <div className="coyl-lg-12 d-flex justify-content-center">
              <ul id="projects-flters">
                <li data-filter="*" className="filter-active">
                  All
                </li>
                <li data-filter=".filter-app">App</li>
                <li data-filter=".filter-card">Card</li>
                <li data-filter=".filter-web">Web</li>
              </ul>
            </div>
          </div> */}

          <div className="row projects-container">
            {ProjectsData.projects &&
              ProjectsData.projects.map((project, index) => {
                return (
                  <div
                    className="col-lg-4 col-md-6 col-6 projects-item filter-app d-flex"
                    key={index}
                  >
                    <div className="projects-wrap align-items-center">
                      <img
                        src={project.displayImage}
                        className="img-fluid align-self-center"
                        alt="Project-DisplayImage"
                      />
                      <div className="projects-info">
                        <h4>{project.title}</h4>
                        <p>{project.type}</p>
                        <div className="projects-links">
                          <Link
                            to="#"
                            className="projects-lightbox"
                            title="App 1"
                            onClick={() => {
                              handleShow();
                              handleContent(project);
                            }}
                          >
                            <i className="bi bi-radioactive"></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            <ProjectsModal
              show={show}
              onHide={handleClose}
              project={project}
            />
          </div>
          
        </div>
        {/* <!-- End Projects Section --> */}
      </section>
    </div>
  );
}

export default Projects;
